import { render } from "./SampleEdit.vue?vue&type=template&id=901c1900"
import script from "./SampleEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Sample/SampleEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "901c1900"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('901c1900', __exports__)) {
    api.reload('901c1900', __exports__)
  }
  
  module.hot.accept("./SampleEdit.vue?vue&type=template&id=901c1900", () => {
    api.rerender('901c1900', render)
  })

}


export default __exports__